import { media } from "src/styles/mixins";
import styled from "styled-components";

export const VotesOuterWrapper = styled.div<{
  isOpen?: boolean;
  isDeckHidden?: boolean;
}>`
  position: absolute;
  left: 0;
  transition: height 0.2s ease-in-out;
  height: ${({ isOpen, isDeckHidden }) =>
    isOpen
      ? `calc(100vh - var(--nav-height) ${
          !isDeckHidden ? "- var(--user-deck-height)" : ""
        } - 10px)`
      : "40px"};
  min-width: 100%;
  z-index: -1;
  padding: 0 10px;
  bottom: 100%;

  ${media.up("LAPTOP")`
    min-width: 240px;
    bottom: 0;
    position: fixed;
    padding: 15px;
    z-index:1;
    height: calc(100vh - var(--nav-height));
  `}

  svg {
    transition: transform 0.2s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0)")};
  }
`;

export const VotesWrapper = styled.div`
  border-radius: 16px 16px 0 0;
  border: 2px solid black;
  border-bottom: none;
  width: 100%;
  height: 100%;
  padding: 5px;
  text-align: center;
  background: white;
  position: relative;
  overflow: hidden;

  ${media.up("LAPTOP")`
    padding: 20px;
    border-radius: 16px;
    border-bottom:2px solid black;
  `}
`;

export const VotesTable = styled.div`
  flex-direction: column;
  width: 100%;
  height: calc(100% - var(--user-deck-height));
  align-items: center;
  display: flex;
  overflow-y: auto;
  margin-top: 32px;
`;

export const OpenVotesSummaryButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
`;
